<template>
  <!-- 单行本免费详情 -->
  <div>
    <Topadv v-if="keywords" :keys="keywords" :advId="647"></Topadv>

    <div class="main">
      <!-- 顶部广告条 -->
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span class="crumb" @click="$router.push({ path: '/read' })">阅读</span>
        <span>></span>
        <span style="color: #0091ff">单行本</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <ul class="info">
            <li v-for="(item, i) in infoList" :key="i" @click="detail(item)">
              <div>
                <div class="img">
                  <img :src="item.cover_url" alt />
                </div>
                <div class="cont">
                  <p>{{ item.title }}</p>
                  <div>
                    <span>{{ item.visit_times }} 阅读</span>
                    <span>{{ item.display_time | timefilters }}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="morePage" v-if="show_page">
            <div @click="moreData">
              <p>加载更多</p>
              <div>
                <img src="@/assets/img/more.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <!-- 右侧矩形广告 -->
          <Rightadv v-if="id" :keys="id" :advId="652"></Rightadv>

          <div class="right-box">
            <div class="wechart-box">
              <p class="title">本期封面</p>
              <div>
                <img :src="message_cover" alt />
              </div>
              <p>{{ message_title }}</p>
              <p class="arctileNum">
                {{ message_time | timefilters }}
                <span>单行本</span>
              </p>
            </div>
          </div>
          <!--          <AboutAuthor></AboutAuthor>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFreeList, getChargeList } from "@/api/read";
import Topadv from "@/components/topadv";
import Rightadv from "@/components/rightadv";
import { getTdkList} from "@/api/tdk";

export default {
  name: "read_free",
  data() {
    return {
      show_page: true,
      type: "", //判断单行本，杂志，
      infoList: [],
      id: "",
      page: 1,
      per: 6,
      message_cover: "",
      message_title: "",
      message_time: "",
      is_jurisdiction: false,
      keywords: null
    };
  },
  methods: {
    moreData() {
      this.getList();
    },
    getList() {
      var params = {
        id: this.id,
        page: this.page,
        per: this.per
      };

      getFreeList(params).then(res => {
        this.infoList = this.infoList.concat(res.data.data);
        try {
          this.$ba([
            ["ptype", "list"],
            ["acategory", "theme"],
            ["acname", "专题"],
            ["acategory2", "theme" + this.id],
            ["a2cname", this.$route.params.title],
            ["atype", "article"]
          ]);
        } catch (error) {
          console.log(error);
        }

        if (this.page >= res.data.meta.total_pages) {
          this.show_page = false;
        } else {
          this.page = this.page - 0 + 1;
        }
      });
    },
    // 文章详情
    detail(scope) {
      this.$router.push({
        name: "article_detail",
        params: {
          id: scope.id,
          isRead: true,
          titleType: "单行本",
          readType: "free",
          readId: this.id,
          readTypes: this.type,
          readCover: this.message_cover,
          readTime: this.message_time,
          readSeria: this.message_seria
        }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    
    this.type = this.$route.params.type;
    this.id = this.$route.params.id;
    this.keywords = this.id;

    this.message_cover = this.$route.params.cover;
    this.message_title = this.$route.params.title;
    this.message_time = this.$route.params.time;
    this.resetParams(this, [
      "type",
      "id",
      "is_jurisdiction",
      "message_cover",
      "message_title",
      "message_time"
    ]);
    if (this.type == "Subject") {
      this.show_page = false;
      var params = {
        id: this.id,
        page: this.page,
        per: this.per
      };
      getChargeList(params).then(res => {
        this.infoList = res.data.data.articles;
        this.$ba([
          ["ptype", "list"],
          ["acategory", "subject"],
          ["acname", "单行本"],
          ["acategory2", "subject" + this.id],
          ["a2cname", this.$route.params.title],
          ["atype", "article"]
        ]);
      });
    } else {
      this.getList();
    }
  },
  components: {
    Topadv,
    Rightadv
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}
.info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  li {
    width: 48%;
    background: #fff;
    margin-bottom: 30px;
    cursor: pointer;
    div {
      .img {
        width: 100%;
        height: 230px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .cont {
        padding: 20px 30px;
        p {
          font-size: 20px;
          line-height: 30px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-align: justify;
        }
        div {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #999999;
          margin-top: 10px;
        }
      }
    }
  }
}
.right-box {
  background: #fff;
  text-align: center;
  font-size: 16px;
  margin-bottom: 30px;
  .wechart-box {
    padding: 30px;
    p {
      line-height: 24px;
    }
    .title {
      font-weight: 600;
    }
    div {
      max-width: 200px;
      padding: 20px 30px 10px 30px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .arctileNum {
      font-size: 12px;
      color: #999999;
      span {
        margin-left: 10px;
      }
    }
    .author-info {
      margin-top: 20px;
      li {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        div {
          padding: 0;
        }
        .pic {
          width: 60px;
          height: auto;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        .author-introduce {
          text-align: left;
          font-size: 16px;
          margin-left: 10px;
          .other-introduce {
            font-size: 12px;
            color: #999999;
          }
        }
        .el-button {
          background: #0091ff;
          color: #fff;
          width: 70px;
          height: 30px;
          border-radius: 15px;
          text-align: center;
          vertical-align: middle;
          line-height: 7px;
          font-size: 14px;
          padding: 0;
        }

        .isActice {
          background: #fff;
          color: #0091ff;
          border: 1px solid;
        }
      }
    }
  }
}

//新增
.topBanner {
  position: relative;
  margin: 30px 0;
  display: block;
  // border: 1px solid;
  background: #fff;
  height: 90px;
  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

// 新增广告样式
.rightTop {
  position: relative;
  width: 320px;
  height: 250px;
  background: #fff;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/read/free-detail.vue